import {
  assertionPayload,
  publicKeyRequestOptions,
  webAuthnAvailable
} from '../utils/webauthn.js'

async function initializePasskeyAssistedLogin() {
  const root = document.querySelector('[data-passkey-assisted-login]');
  if (!root) return;

  const passwordForm = document.querySelector('form[data-passkey-assisted-login-form]');
  const optionsForm = root.querySelector('[data-passkey-assisted-options-form]');
  const form = root.querySelector('[data-passkey-assisted-form]');
  let currentRequest;
  let submitting = false;

  if (!webAuthnAvailable()) {
    return;
  }

  window.addEventListener('pageshow', event => {
    // A cached sign-in page can have stale submission and server-side proof state.
    if (event.persisted) window.location.reload();
  });
  passwordForm.addEventListener('submit', () => {
    submitting = true;
    currentRequest?.abort();
  });

  function setValue(name, value) {
    const field = form.querySelector(`[name="${name}"]`);
    field.disabled = value == null;
    field.value = value ?? '';
  }

  function loadCeremony(signal) {
    return fetch(optionsForm.action, {
      method: optionsForm.method,
      headers: { 'Accept': 'application/json' },
      body: new FormData(optionsForm),
      signal
    }).then(response => {
      if (!response.ok) throw new Error('Unable to start passkey authentication');
      return response.json();
    });
  }

  async function authenticate() {
    if (submitting) return;

    currentRequest?.abort();
    const controller = new AbortController();
    currentRequest = controller;

    try {
      const ceremony = await loadCeremony(controller.signal);

      const request = {
        publicKey: publicKeyRequestOptions(ceremony.options),
        signal: controller.signal,
        mediation: 'conditional'
      };

      const assertion = await navigator.credentials.get(request);
      if (!assertion || controller.signal.aborted) return;

      const credential = assertionPayload(assertion);
      setValue('ceremony_id', ceremony.ceremony_id);
      setValue('credential[id]', credential.id);
      setValue('credential[rawId]', credential.rawId);
      setValue('credential[type]', credential.type);
      setValue('credential[response][authenticatorData]', credential.response.authenticatorData);
      setValue('credential[response][clientDataJSON]', credential.response.clientDataJSON);
      setValue('credential[response][signature]', credential.response.signature);
      setValue('credential[response][userHandle]', credential.response.userHandle);
      submitting = true;
      form.submit();
    } catch {
      // Passkey autofill is optional; normal email/password sign-in remains available.
    }
  }

  try {
    if (await window.PublicKeyCredential.isConditionalMediationAvailable?.() && !currentRequest && !submitting) {
      authenticate();
    }
  } catch {
    // Normal email/password sign-in remains available.
  }
}

document.addEventListener('DOMContentLoaded', initializePasskeyAssistedLogin);
